import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const styles = theme => ({
  modal: {
    margin: 'auto',
  },
  contentWrapper: {
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: 20,
    top: 10,
    width: 40,
    [theme.breakpoints.up('md')]: {
      right: 40,
    },
  },
  paper: {},
  dialogTitle: {
    padding: `22px 55px 12px 55px`,
    borderBottom: '1px solid #E1E4EB',
  },
  dialogContent: {
    padding: '14px',
    minHeight: 300,
    [theme.breakpoints.up('md')]: {
      padding: '14px 29px',
    },
  },
  close: {
    width: 36,
    [theme.breakpoints.up('md')]: {
      width: 40,
    },
  },
});

const BoxModal = ({ open, heading, modalWidth, handleClose, fullScreen, classes, children }) => {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={modalWidth}
      fullScreen={fullScreen}
      classes={{
        paper: classes.paper,
      }}
    >
      {heading && (
        <DialogTitle className={classes.dialogTitle} align="center">
          <Typography variant="h3" component="span">
            <strong>{heading}</strong>
          </Typography>
          <IconButton aria-label="Close" className={classes.closeButton} onClick={handleClose}>
            <img src="/static/images/close.svg" className={classes.close} alt="close" />
          </IconButton>
        </DialogTitle>
      )}
      <DialogContent className={classes.dialogContent}>{children}</DialogContent>
    </Dialog>
  );
};

BoxModal.defaultProps = {
  modalWidth: 'md',
};
BoxModal.propTypes = {
  modalWidth: PropTypes.string,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  heading: PropTypes.string,
  fullScreen: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withMobileDialog()(BoxModal));
